import React, { useEffect, useState } from "react";
import PageHeading from "../components/PageHeading";
import QuillEditor from "../components/QuillEditor";
import DButton from "../components/DButton";
import DCard from "../components/DCard";
import { toast } from "react-hot-toast";
import FormikContainer from "../components/Formik/FormikContainer";
import { Form } from "formik";
import FieldContainer from "../components/Formik/FieldContainer";
import * as Yup from "yup";
import { Heading, Spinner } from "@chakra-ui/react";
import aboutServices from "../services/about";
import DSpinner from "../components/DSpinner";

const validationSchema = Yup.object().shape({
    facebook: Yup.string().url("الرابط غير محقق"),
    whatsapp: Yup.string().url("الرابط غير محقق"),
    email: Yup.string().email("غير محقق"),
});
const About = ({ title }) => {
    const [aboutAr, setAboutAr] = useState("");
    const [aboutEn, setAboutEn] = useState("");
    const [initialValues, setInitialValues] = useState({
        facebook: "",
        whatsapp: "",
    });
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const getAbout = () => {
            aboutServices
                .getAbout()
                .then(res => {
                    setLoading(false);
                    const about = JSON.parse(res.data.data.message);
                    setAboutAr(about.ar);
                    setAboutEn(about.en);
                    setInitialValues(JSON.parse(res.data.data.social_media));
                })
                .catch(err => {
                    setLoading(false);
                    console.log(err);
                });
        };
        getAbout();
    }, []);
    const onSubmit = (values, { setSubmitting }) => {
        if (aboutAr !== "" && aboutEn !== "") {
            const data = {
                message: JSON.stringify({
                    ar: aboutAr,
                    en: aboutEn,
                }),
                social_media: JSON.stringify({
                    facebook: values.facebook,
                    whatsapp: values.whatsapp,
                    email: values.email,
                }),
            };
            aboutServices
                .updateAbout(data)
                .then(res => {
                    toast.success("تم التعديل بنجاح");
                })
                .catch(err => {
                    console.log(err);
                    toast.error("فشل التحديث");
                });
        } else {
            toast.error("من نحن يجب ان لايكون فارغ");
        }
        setTimeout(() => {
            setSubmitting(false);
        }, 1500);
    };

    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard
                className={
                    loading ? "min-h-[400px] relative" : "overflow-hidden"
                }
            >
                {loading ? (
                    <DSpinner />
                ) : (
                    <>
                        {" "}
                        <div className="mb-4">
                            <Heading as="h2" size="md" className="mb-4">
                                من نحن (العربية):
                            </Heading>
                            <QuillEditor
                                value={aboutAr}
                                setValue={setAboutAr}
                            />
                        </div>
                        <div className="mb-4">
                            <Heading as="h2" size="md" className="mb-4">
                                من نحن (الانجليزية):
                            </Heading>
                            <QuillEditor
                                value={aboutEn}
                                setValue={setAboutEn}
                            />
                        </div>
                        <FormikContainer
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmit}
                        >
                            {({ isSubmitting }) => {
                                return (
                                    <Form>
                                        <Heading
                                            as="h2"
                                            size="md"
                                            className="mb-4"
                                        >
                                            وسائل التواصل:
                                        </Heading>
                                        <div className="grid md:grid-cols-2 gap-4">
                                            <FieldContainer
                                                name="email"
                                                label="البريد الالكتروني"
                                                id="email"
                                            />
                                            <FieldContainer
                                                name="facebook"
                                                label="رابط الفيسبوك"
                                                id="facebook"
                                            />
                                            <FieldContainer
                                                name="whatsapp"
                                                label="رابط الواتساب"
                                                id="whatsapp"
                                            />
                                        </div>
                                        <DButton
                                            type="submit"
                                            disabled={isSubmitting}
                                            className="mx-auto min-w-[150px] flex items-center justify-center text-white"
                                        >
                                            {isSubmitting ? (
                                                <Spinner />
                                            ) : (
                                                "تحديث المحتوى"
                                            )}
                                        </DButton>
                                    </Form>
                                );
                            }}
                        </FormikContainer>
                    </>
                )}
            </DCard>
        </div>
    );
};

export default About;
